import React, { useState } from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import MobileVerification from './Components/MobileVerification';
import Plans from './Components/Plans';
import VoucherCount from './Components/VoucherCount';
import Confirm from './Components/Confirm';
import Payment from './Components/Payment';
import VoucherQueue from './Components/VoucherQueue';
import Summary from './Components/Summary';

function VoucherQueueing () {
   
  const[mobile,setMobile]=useState(null);
  const[balanceQueueMessage,setBalanceQueueMessage]=useState(null);
  const[queueLImit,setQueueLImit]=useState(0);
  const[choosedplan_id,selectedPlan]=useState(false);
  const[choosedplan_name,selectedPlanName]=useState(false);
  const[PageName,setPageName]=useState('home');
  const[planData, setPlanData] = useState([])
  const[choosedVoucherCount, setchoosedVoucherCount] = useState(0);
  const[confirmation,setConfirmation]=useState([]);
  const[summaryData,setSummary]=useState([]);

 

  const handlePagename = (input, e) => {
    setPageName(input);
  };

  const verifiedMobile = (input, e) => {
    setMobile(input);
  };

  
  const balanceQueueText = (input, e) => {
    setBalanceQueueMessage(input);
  };

  const handlePlans = (input, e) => {
    setPlanData(input);
  };


  const handleQueueLimit = (input, e) => {
    setQueueLImit(input);
  };


  const handleSummaryData = (input, e) => {
    setSummary(input);
  };


  const SelectedPrepaidPlanId = (input, e) => {
    selectedPlan(input);
  };


  const SelectedPrepaidPlanName = (input, e) => {
    selectedPlanName(input);
  };

  
  const VoucherCountSetup = (input, e) => {
    setchoosedVoucherCount(input);
  };

  const confirmationData = (input, e) => {
    setConfirmation(input);
  };


  const orderSummary = (input, e) => {

    setSummary(input);

    // reset all states
    setMobile(null);
    setBalanceQueueMessage(null);
    setQueueLImit(0);
    selectedPlan(false);
    selectedPlanName(false);
    setPlanData([]);
    setchoosedVoucherCount(0);
    setConfirmation([]);
    
  };




 
  return (
    <div>

      <DashboardLayout>
      <DashboardNavbar />
      <VoucherQueue />

        {PageName ==='home' &&  
          <MobileVerification setPlanData={handlePlans} handlePage={handlePagename} handleLimit={handleQueueLimit} queuedMobile={verifiedMobile}  balanceQueue={balanceQueueText} />
        }


        {PageName ==='plan' &&  
          <Plans planData={planData} handlePage={handlePagename}  setSelectedPrepaidPlanId={SelectedPrepaidPlanId} setSelectedPrepaidPlanName={SelectedPrepaidPlanName}/>
        }


        {PageName ==='voucher_count' &&  
          <VoucherCount mobile={mobile} handlePage={handlePagename} choosedplan_id={choosedplan_id} choosedplan_name={choosedplan_name} queueLImit={queueLImit} balanceQueueMessage={balanceQueueMessage}  selectedVoucherCount={VoucherCountSetup} confirmData={confirmationData} />
        }


        {PageName ==='confirm' &&  
          <Confirm  choosedVoucherCount={choosedVoucherCount} mobile={mobile} handlePage={handlePagename} choosedplan_id={choosedplan_id} confirmation={confirmation}  orderSummaryData={orderSummary} />
        }


        {PageName ==='payment' &&  
          <Payment  choosedVoucherCount={choosedVoucherCount} mobile={mobile} handlePage={handlePagename} choosedplan_id={choosedplan_id}  orderSummaryData={orderSummary}/>
        }


        {PageName ==='summary' &&  
          <Summary summaryData={summaryData} />
        }


      </DashboardLayout>
    </div>
  )
}

export default VoucherQueueing